import { sharedSchema } from "@shared-database/pgSchema";
import { File } from "@shared-database/models/file";
import {
  leoEnum,
  leoNotNullForeignID,
  timestampColumns,
} from "@shared-database/utils";
import { createInsertSchema } from "drizzle-zod";

import { text } from "drizzle-orm/pg-core";
import { ImageScaleEnumValues } from "@shared-database/enums";

import { primaryKey } from "drizzle-orm/pg-core";
import type { z } from "zod";

export const scaleEnum = leoEnum("scaleSize", ImageScaleEnumValues);

export const ScaledImage = sharedSchema.table(
  "scaledImage",
  {
    ...timestampColumns,
    fileId: leoNotNullForeignID("fileId").references(() => File.id, {
      onDelete: "cascade",
    }),
    name: text("name").notNull(),
    scale: scaleEnum("scale").notNull(),
  },
  (scaledImage) => [
    primaryKey({
      columns: [scaledImage.fileId, scaledImage.scale],
    }),
  ],
);
export const insertScaledImage = createInsertSchema(ScaledImage);
export type InsertScaledImage = z.infer<typeof insertScaledImage>;
